/* eslint-disable import/first */

export * from '@vindo/store'
import {configure} from '@vindo/store'

/**
 * Reducers
 */
import * as auth from './reducers/auth'
import * as modal from './reducers/modal'
import * as navigation from './reducers/navigation'


configure({
  storage: {
    key: 'root',
    engine: localStorage
  },
  context: {
    user: {},
    navigation
  },
  reducers: {modal, auth}
})